import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';

import type { PostListItem } from '@/entities/post';
import { paginationRequestSchema, type PaginationResponse } from '@/shared/schema/pagination';
import { CAMPAIGN_LABEL_TYPE, CAMPAIGN_POSTS_SORT } from '../constant';

export const fetchCampaignPostsRequestSchema = z.object({
  sort: z.enum(CAMPAIGN_POSTS_SORT).optional(),
  ...paginationRequestSchema.shape,
});

export type FetchCampaignPostsRequest = z.input<typeof fetchCampaignPostsRequestSchema>;

export type CampaignDetailPost = {
  campaign_post_id: string;
  label: CAMPAIGN_LABEL_TYPE;
  post: PostListItem;
  is_new: boolean;
  source: 'manual' | 'auto';
};

export type CampaignPostListResponse = {
  items: Array<CampaignDetailPost>;
  pagination: PaginationResponse;
};

export async function FetchCampaignPosts(
  campaignId: string,
  recent: boolean,
  request?: FetchCampaignPostsRequest,
  signal?: AbortSignal,
): Promise<CampaignPostListResponse> {
  const parsedRequest = fetchCampaignPostsRequestSchema.parse(request ?? {});
  const endpoint = recent ? 'recent_posts' : 'posts';
  const response = await socialApiClient.get<CampaignPostListResponse>(
    `campaigns/${campaignId}/${endpoint}`,
    {
      searchParams: parsedRequest,
      signal,
    },
  );

  return await response.json();
}
